"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inquiryAnswerTemplate = void 0;
var utils_1 = require("../../utils");
var inquiryAnswerTmeplatesUrl = '/inquiry-answer-templates';
var inquiryAnswerTemplateNoUrl = '/{inquiryAnswerTemplateNo}';
exports.inquiryAnswerTemplate = function (axios) {
    return {
        // [Inquiry Answer Template]
        getInquiryAnswerTemplates: function (getInquiryAnswerTemplatesRequest) {
            return axios.get(inquiryAnswerTmeplatesUrl, getInquiryAnswerTemplatesRequest);
        },
        postInquiryAnswerTemplates: function (postInquiryAnswerTemplatesRequest) {
            return axios.post(inquiryAnswerTmeplatesUrl, postInquiryAnswerTemplatesRequest.data);
        },
        getInquiryAnswerTemplatesNo: function (pathTemplateNoQueryMallNoRequest) {
            var url = utils_1.paramPathchange("" + inquiryAnswerTmeplatesUrl + inquiryAnswerTemplateNoUrl, pathTemplateNoQueryMallNoRequest);
            return axios.get(url, pathTemplateNoQueryMallNoRequest);
        },
        putInquiryAnswerTemplatesNo: function (putInquiryAnswerTemplatesNoRequest) {
            var url = utils_1.paramPathchange("" + inquiryAnswerTmeplatesUrl + inquiryAnswerTemplateNoUrl, putInquiryAnswerTemplatesNoRequest);
            return axios.put(url, putInquiryAnswerTemplatesNoRequest.data);
        },
        deleteInquiryAnswerTemplatesNo: function (pathTemplateNoQueryMallNoRequest) {
            var url = utils_1.paramPathchange("" + inquiryAnswerTmeplatesUrl + inquiryAnswerTemplateNoUrl, pathTemplateNoQueryMallNoRequest);
            return axios.delete(url, pathTemplateNoQueryMallNoRequest);
        },
        putInquiryAnswerTemplatesNoOrder: function (putInquiryAnswerTemplatesNoOrderRequest) {
            var url = utils_1.paramPathchange("" + inquiryAnswerTmeplatesUrl + inquiryAnswerTemplateNoUrl + "/order", putInquiryAnswerTemplatesNoOrderRequest);
            return axios.put(url, putInquiryAnswerTemplatesNoOrderRequest.data);
        }
    };
};
